import React, { useEffect, useState } from "react";
import { api } from "@/api/client";
import TopBar from "@/components/TopBar";
import NotificationBanner from "@/components/NotificationBanner";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Clock, LogIn, Receipt, Upload, History as HistoryIcon, FileDown } from "lucide-react";

export default function DriverHome() {
  const { t } = useTranslation();
  const [dash, setDash] = useState(null);

  useEffect(() => {
    api.get("/reports/dashboard/driver").then((r) => setDash(r.data)).catch(() => {});
  }, []);

  const Stat = ({ label, value, hint, cls = "primary", testId }) => (
    <div className={`card stat ${cls}`} data-testid={testId}>
      <div className="stat-label">{label}</div>
      <div className="stat-value">{value}</div>
      {hint && <div className="stat-hint">{hint}</div>}
    </div>
  );

  return (
    <div className="shell">
      <TopBar />
      <div className="container">
        <h1 className="page-title">{t("driver.home")}</h1>
        <p className="page-sub">{t("common.welcome")}</p>

        <NotificationBanner testIdPrefix="driver-notif" style={{ marginBottom: 20 }} />
        <div className="grid grid-4" style={{ marginBottom: 20 }}>
          <Stat testId="stat-today-att" label={t("driver.todayAttendance")}
            value={dash?.today_attendance ? `${dash.today_attendance.start_time || "-"} → ${dash.today_attendance.end_time || "-"}` : t("common.none")}
            hint={dash?.today_attendance ? `${dash.today_attendance.working_hours || 0}h` : ""} />
          <Stat testId="stat-today-exp" label={t("driver.todayExpenses")} value={`¥${(dash?.today_expenses_total || 0).toLocaleString()}`} cls="success" />
          <Stat testId="stat-month-hours" label={t("driver.monthlyHours")} value={`${dash?.monthly_working_hours || 0}h`} cls="warn" />
          <Stat testId="stat-month-exp" label={t("driver.monthlyExpense")} value={`¥${(dash?.monthly_expense_total || 0).toLocaleString()}`} cls="danger" />
        </div>

        <div className="mega-grid">
          <Link to="/driver/attendance" className="mega-btn" data-testid="mega-attendance">
            <div className="mega-icon"><LogIn size={22} /></div>
            <div>
              <div className="mega-title">{t("driver.clockIn")} / {t("driver.clockOut")}</div>
              <div className="mega-sub">勤怠を登録・提出</div>
            </div>
          </Link>
          <Link to="/driver/expense" className="mega-btn" data-testid="mega-expense">
            <div className="mega-icon" style={{ background: "rgba(22,163,74,0.10)", color: "#16A34A" }}><Receipt size={22} /></div>
            <div>
              <div className="mega-title">{t("driver.registerExpense")}</div>
              <div className="mega-sub">経費と領収書を登録</div>
            </div>
          </Link>
          <Link to="/driver/history" className="mega-btn" data-testid="mega-history">
            <div className="mega-icon" style={{ background: "rgba(245,158,11,0.10)", color: "#F59E0B" }}><HistoryIcon size={22} /></div>
            <div>
              <div className="mega-title">{t("driver.history")}</div>
              <div className="mega-sub">勤怠と経費の履歴</div>
            </div>
          </Link>
          <Link to="/driver/reports" className="mega-btn" data-testid="mega-reports">
            <div className="mega-icon" style={{ background: "rgba(220,38,38,0.10)", color: "#DC2626" }}><FileDown size={22} /></div>
            <div>
              <div className="mega-title">{t("driver.downloadReport")}</div>
              <div className="mega-sub">月次レポート (Excel/PDF)</div>
            </div>
          </Link>
        </div>

        {dash?.pending_approvals > 0 && (
          <div className="card" style={{ marginTop: 20 }} data-testid="pending-banner">
            <div className="card-body">
              <div className="card-title">{t("driver.pendingApprovals")}: <span style={{ color: "#F59E0B" }}>{dash.pending_approvals}</span></div>
              <div className="card-sub">提出済みの承認待ち件数です。</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
